import axios from '@/store/config';
import { filter, reverse } from 'lodash'

export default {
  //state
  state : {
    Messages : []
  },
  // getters
  getters : {
    /**
     * Hämtar ut alla meddelanden
     */
    infoscreenMessages : state => state.Messages,

    /**
     * Hämtar ut alla meddelanden bilder
     */
    infoscreenImageMessages : state => filter(state.Messages, Message => !!Message.Image),

        /**
     * Hämtar ut alla meddelanden HTML
     */
    infoscreenHtmlMessages : state => filter(state.Messages, Message => !!Message.MessageHTML)
  },
  // actions
  actions : {

    /**
     * Hämtar data från Passad på det första lägenhets nr kontraktet.
     */
    getInfoscreenMessages ({ commit, state, rootState, getters, dispatch}) {
      this.cache.dispatch('fetchContracts').then(() => {

        if(getters.hasApartment){
          const apartmentNumber = getters.getApartments[0].rentalObjectCode;

          if (!apartmentNumber) return;

          axios.get('/rentalobjects/'+apartmentNumber+'/infoscreen')
          .then((response) => {

            commit('setInfoscreenData', response.data);
          })
        }
        return rootState.contracts.appartments;
      })
    }
  },

  //mutations
  mutations : {
    setInfoscreenData(state, payload) {
      //Polyfill
      if (typeof NodeList !== "undefined" && NodeList.prototype && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = Array.prototype.forEach;
      }
      //Revers order
      reverse(payload.Messages)

      //Get all inline images and store them on the side
      payload.Messages.forEach(function(message, index){
        var tempNode = document.createElement('div'),
            images = [];
        tempNode.innerHTML = message.HtmlBody;
        tempNode.querySelectorAll('img').forEach(function(img) {
           images.push({
             src: img.src,
             alt: img.alt
           });
           //img.remove(); //IE...
           if (img && img.parentNode) img.parentNode.removeChild(img);
        });

        //remove all inline styles
        tempNode.innerHTML = tempNode.innerHTML.replace(/ style=("|\')(.*?)("|\')/g, '');

        message.index = index;
        message.body_message = tempNode.innerHTML;
        message.body_images = images;
      });

      state.Messages = payload.Messages;
    }
  }
}
